import { render, staticRenderFns } from "./Crew-overview.vue?vue&type=template&id=411c68d2"
import script from "./Crew-overview.vue?vue&type=script&lang=js"
export * from "./Crew-overview.vue?vue&type=script&lang=js"
import style0 from "./Crew-overview.vue?vue&type=style&index=0&id=411c68d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports